export const EVENT = {
	SESSION_EXPIRED: "SESSION_EXPIRED",
};